module.exports = __webpack_public_path__ + "static/section6-0e4ab03408b09d452722694ab45c4291.svg";